import React from "react";
import InteractivesHost from "../../interactives/host/InteractivesHost";
import { getInteractivesDataAttr } from "../../../utils/interactivesHelper";
import {
  MOCK_AD_COMPONENTS,
  MOCK_AD_COMPONENTS_300x250,
  MOCK_AD_COMPONENTS_300x600,
} from "../../interactives/adWidgets/mockAdComponents";

// Default RSS feed URL — can be overridden via data-feedurl attribute or data prop
const DEFAULT_FEED_URL =
  "https://q.loop-feed.com/v1/topic/cmi5nqc0d0ku6hxyl853a393j/content&service=rss&limit=20";

/**
 * Widget wrapper for the Interactives feature.
 * Routes dataType to the appropriate component.
 *
 * Supported dataTypes:
 *  "interactives-rss"  - RSS feed with 300x250 match head or ad slots
 *
 * DOM attributes consumed:
 *  data-feedurl        - RSS feed URL (defaults to loop-feed API)
 *  data-matchid        - Football match ID to render as the 300x250 match head widget
 *  data-base-url       - API base URL (required when data-matchid is set)
 *  data-difference     - Timezone offset (e.g. "+5")
 *  data-matchsport     - Sport for the match head (default: "football")
 *  data-maxitems       - Max RSS items to show
 */
const InteractivesWidgetWrap = ({
  dataType = "",
  data = null,
  loadCSS = true,
  dataClient = false,
  websiteBaseUrl = "",
  dataPath = "",
  dictionary = {},
  containerEl,
}) => {
  switch (dataType) {
    case "interactives-rss": {
      const adInsertAfter = parseInt(getInteractivesDataAttr("adafter", containerEl) || "3", 10);
      const difference    = getInteractivesDataAttr("difference", containerEl) || "+0";

      // Socket config for live match updates in MatchHeadWidget ads
      const socketConfig = data?.socketConfig || {
        socketUrl: getInteractivesDataAttr("socketurl", containerEl) || "",
        channel:   getInteractivesDataAttr("channel", containerEl) || "FootballMatch",
        event:     getInteractivesDataAttr("event", containerEl) || "FootballMatchDetails",
      };

      // Slider ratio — if set (e.g. "300x250"), compact slider; if empty, large dialog
      const sliderRatio = getInteractivesDataAttr("ratio", containerEl) || data?.sliderRatio || "";

      // Pick mock components based on slider ratio
      const mockComponents =
        sliderRatio === "300x600"
          ? MOCK_AD_COMPONENTS_300x600.components
          : sliderRatio === "300x250"
            ? MOCK_AD_COMPONENTS_300x250.components
            : MOCK_AD_COMPONENTS.components;

      // Component-based ad config — cycles through components array
      // When the real API is ready, replace mock data with the API response.
      const adConfig = data?.adConfig || [
        {
          type: "components",
          components: mockComponents,
          insertAfter: adInsertAfter,
          difference,
          socketConfig,
        },
      ];

      // Caption toggle — "false" hides body/footer overlay in slider cards
      const captionAttr = getInteractivesDataAttr("caption", containerEl);
      const showCaption = captionAttr === "false" ? false : (data?.showCaption !== false);

      return (
        <InteractivesHost
          ServerData={data?.items || null}
          feedUrl={data?.feedUrl || DEFAULT_FEED_URL}
          adConfig={adConfig}
          layout={data?.layout || 300}
          gap={data?.gap || 16}
          maxItems={data?.maxItems || 20}
          loadCSS={loadCSS}
          dataClient={dataClient}
          dictionary={dictionary}
          sliderRatio={sliderRatio}
          showCaption={showCaption}
          containerEl={containerEl}
        />
      );
    }

    default:
      return null;
  }
};

export default InteractivesWidgetWrap;
